const getNextItemInArray = (currentItem: any, array: any[]  ) => {
    const currentIndex = array.indexOf(currentItem);
    if (currentIndex === -1) {
        return array[0];
    }
    const nextIndex = (currentIndex + 1) % array.length;
    return array[nextIndex];
}

export default getNextItemInArray;const getNextItemInArray = (currentItem: any, array: any[]  ) => {
    const currentIndex = array.indexOf(currentItem);
    if (currentIndex === -1) {
        return array[0];
    }
    const nextIndex = (currentIndex + 1) % array.length;
    return array[nextIndex];
}

export default getNextItemInArray;